<div *ngIf="imageToDisplay" class="image-wrapper">
  <img matRipple [src]="imageToDisplay" />
</div>

<button mat-mini-fab class="previous-button" (click)="previousImage()">
  <mat-icon>navigate_before</mat-icon>
</button>
<button mat-mini-fab class="next-button" (click)="nextImage()">
  <mat-icon>navigate_next</mat-icon>
</button>

<button mat-mini-fab class="close-button" (click)="closeDialog()">
  <mat-icon>close</mat-icon>
</button>
